import React, { Fragment, useEffect } from 'react';
import Flotante from '../Flotante';
import ContactCircle from '../ContactCircle';

const FlotanteWrapper = (props) => {
  const {
    Modal, SvgIconLoader, modalAtencionConfig, components, visible, flotanteProps, component, product, taggingInfo,
  } = props;

  switch (props.component) {
    case 'contact-circle':
      components['Button-llamada'].product = product || components['Button-llamada'].product;
      taggingInfo.componentProduct = product;
      taggingInfo.componentVariation = components['Button-llamada'].campaign || taggingInfo.componentVariation;
      break;
    case 'new-flotante':
    default:
      flotanteProps.product = product || flotanteProps.product;
      taggingInfo.componentProduct = product;
      taggingInfo.componentVariation = flotanteProps.campaign || taggingInfo.componentVariation;
      break;
  }

  return (
    <Fragment>
      {component === 'contact-circle' && (
        <ContactCircle
          Modal={Modal}
          SvgIconLoader={SvgIconLoader}
          modalAtencionConfig={modalAtencionConfig}
          visible={visible}
          components={components}
          taggingInfo={taggingInfo}
        />
      )}
      {component === 'new-flotante' && (
        <Flotante
          Modal={Modal}
          SvgIconLoader={SvgIconLoader}
          modalAtencionConfig={modalAtencionConfig}
          visible={visible}
          flotanteProps={flotanteProps}
          taggingInfo={taggingInfo}
        />
      )}
    </Fragment>
  );
};

export default FlotanteWrapper;
